var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsDownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 16V9a7.008 7.008 0 0 0-7-7H2v14h6.465l3.577 5.366.845 5.917A2.01 2.01 0 0 0 14.867 29H17a3.003 3.003 0 0 0 3-3v-6h6a4.004 4.004 0 0 0 4-4zM8 14H4V4h4v10zm20 2a2.002 2.002 0 0 1-2 2h-8v8a1 1 0 0 1-1 1h-2.133l-.91-6.366L10 14.697V4h13a5.006 5.006 0 0 1 5 5v7z",
    fill: "#2D809A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsDownIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumbs_down_icon.0bbcd0bc04e24a0d77a84f52dba8479c.svg";